<template>
    <div class="tabs">
        <input type="radio" id="tab1" name="tab-control" checked>
        <input type="radio" id="tab2" name="tab-control">
        <input type="radio" id="tab3" name="tab-control">  
        <input type="radio" id="tab4" name="tab-control">
        <ul>
            <li title="e-commerce">
                <label for="tab1" data-qa="eCommerceTabButton" role="button" style="font-size: 1.8em;">
                    <svg viewBox="0 0 24 24">
                        <path d="M19.09,5.06a.71.71,0,0,0-.56-.27H5.44L5.38,4.3v0A4,4,0,0,0,1.47.85a.72.72,0,0,0-.72.72.73.73,0,0,0,.72.73A2.51,2.51,0,0,1,4,4.46L5,14A2.85,2.85,0,0,0,6.24,16a2.13,2.13,0,1,0,3.79.5h3.12a2.14,2.14,0,1,0,2-1.45H7.86A1.44,1.44,0,0,1,6.42,13.8l0-.19h8.85a2.91,2.91,0,0,0,2.83-2.31l.38-1.85a.73.73,0,0,0-.15-.6.71.71,0,0,0-.56-.26H14.5l.19-2.35h3l0,.07a.72.72,0,0,0,.56.85l.15,0a.73.73,0,0,0,.71-.58l.19-.94a.73.73,0,0,0-.15-.6ZM15.17,16.54a.69.69,0,1,1-.69.69A.69.69,0,0,1,15.17,16.54ZM8,16.54a.69.69,0,1,1-.68.69A.69.69,0,0,1,8,16.54ZM5.6,6.24H8.42l.19,2.35H5.85Zm.65,5.92L6,10H8.73l.17,2.13Zm6.51,0H10.35L10.18,10h2.75Zm.29-3.57h-3L9.88,6.24h3.36ZM16.86,10l-.2,1a1.44,1.44,0,0,1-1.41,1.15h-1L14.38,10Z" transform="translate(-0.75 -0.85)"/>
                    </svg>
                    <br>
                    <span>{{ $t('ecommerce') }}</span>
                </label>
            </li>
            <li title="inventory">
                <label for="tab2" data-qa="inventoryTabButton" role="button" style="font-size: 1.8em;">
                    <svg viewBox="0 0 24 24">
                        <path d="M15.64,14.48l2.51-11-.74-.15-2.48,11A3.39,3.39,0,0,1,15.64,14.48Z" transform="translate(-1.74 -0.25)"/><path d="M3.08.25,1.74,1.6H3.08Z" transform="translate(-1.74 -0.25)"/><path d="M7.79.25h-4v2h-2V8.32H7.79ZM6.45,7.65h-4V3.28H4.09V4h-1V7H5.77V5.63h.68Zm-2-1.54L3.52,5.2,4,4.72l.44.44L6.54,3,7,3.52Z" transform="translate(-1.74 -0.25)"/><path d="M3.6,14.36,3.43,15a.28.28,0,0,0,0,.09.37.37,0,0,0,.3.36L11.85,17a3.12,3.12,0,0,1,.5-1.3L4.1,14A.44.44,0,0,0,3.6,14.36Z" transform="translate(-1.74 -0.25)"/><path d="M4.49,13.43l8.38,1.68a3.07,3.07,0,0,1,1.36-.68l1.38-6.15-2.24-.45-.64,2.22-4-.8L9.35,7l-.89-.17V9h-3Z" transform="translate(-1.74 -0.25)"/><path d="M11,7.36l-1-.2L9.56,8.73l1,.21Z" transform="translate(-1.74 -0.25)"/><path d="M20.82,2.26l-3-.6-.23,1,3,.6h.18a.52.52,0,0,0,.1-1Z" transform="translate(-1.74 -0.25)"/><path d="M16.27,14.73a2.81,2.81,0,0,1,.75.57L17.55,13l-.84-.17Z" transform="translate(-1.74 -0.25)"/><path d="M15.85,17.39a1,1,0,1,1-1-1A1,1,0,0,1,15.85,17.39Z" transform="translate(-1.74 -0.25)"/><path d="M17.57,9.06l.84.17.11-.53-.6-1.2Z" transform="translate(-1.74 -0.25)"/><path d="M14.85,15a2.36,2.36,0,1,0,2.35,2.35A2.36,2.36,0,0,0,14.85,15Zm0,4a1.68,1.68,0,1,1,1.68-1.68A1.68,1.68,0,0,1,14.85,19.07Z" transform="translate(-1.74 -0.25)"/><path d="M16.86,12.14l.84.17.56-2.43-.84-.17Z" transform="translate(-1.74 -0.25)"/><path d="M12.71,7.7l-1-.21-.45,1.58,1,.2Z" transform="translate(-1.74 -0.25)"/>
                    </svg>
                    <br>
                    <span>{{ $t('inventory') }}</span>
                </label>
            </li>
            <li title="support">
                <label for="tab3" data-qa="supportTabButton" role="button" style="font-size: 1.8em;">
                    <svg viewBox="0 0 24 24">
                      <path d="M1.35,11.85v2.26a2.08,2.08,0,0,0,2.08,2.07H4.56a.56.56,0,0,0,.56-.57V9.77H3.43A2.08,2.08,0,0,0,1.35,11.85Z" transform="translate(-1.35 -0.35)"/><path d="M14.58,11.47v-3a1.32,1.32,0,0,0-1.32-1.31H8.74A1.32,1.32,0,0,0,7.42,8.45v3a1.32,1.32,0,0,0,1.32,1.32H10l2.11,1.75a.53.53,0,0,0,.36.13.52.52,0,0,0,.24-.05.55.55,0,0,0,.32-.51V12.79h.19A1.32,1.32,0,0,0,14.58,11.47Zm-2.83-.94h-1.5A.57.57,0,0,1,9.68,10a.56.56,0,0,1,.57-.56h1.5a.56.56,0,0,1,.57.56A.57.57,0,0,1,11.75,10.53Z" transform="translate(-1.35 -0.35)"/><path d="M8.93,18.52a1.13,1.13,0,0,0,1.13,1.13h1.88a1.13,1.13,0,1,0,0-2.26H10.06A1.12,1.12,0,0,0,8.93,18.52Z" transform="translate(-1.35 -0.35)"/><path d="M17.26,17.31v.11a.57.57,0,0,1-.57.57H14.14a2.26,2.26,0,0,1,.06.53,2.35,2.35,0,0,1-.08.6h2.57a1.7,1.7,0,0,0,1.7-1.7v-.11Z" transform="translate(-1.35 -0.35)"/><path d="M18.57,9.77H16.88v5.84a.56.56,0,0,0,.56.57h1.13a2.08,2.08,0,0,0,2.08-2.07V11.85A2.08,2.08,0,0,0,18.57,9.77Z" transform="translate(-1.35 -0.35)"/><path d="M16.76,2.74A8.14,8.14,0,0,0,2.86,8.49v.15H5.12V8.49a5.88,5.88,0,1,1,11.76,0v.15h2.26V8.49A8.09,8.09,0,0,0,16.76,2.74Z" transform="translate(-1.35 -0.35)"/>
                    </svg>
                    <br>
                    <span>{{ $t('support') }}</span>
                </label>
            </li>
            <li title="metrics">
                <label for="tab4" data-qa="metricsTabButton" role="button" style="font-size: 1.8em;">
                    <svg viewBox="0 0 24 24">
                      <path d="M14.37,18.67a3.72,3.72,0,0,1-1.19-2.32.43.43,0,0,0-.43-.43H9.23a.44.44,0,0,0-.43.44,3.57,3.57,0,0,1-1.17,2.31.44.44,0,0,0-.09.48.43.43,0,0,0,.4.27h6.12a.43.43,0,0,0,.4-.27A.44.44,0,0,0,14.37,18.67Z" transform="translate(-0.51 -1.93)"/><path d="M20,1.93H2A1.54,1.54,0,0,0,.51,3.46v11.8A1.53,1.53,0,0,0,2,16.79H20a1.53,1.53,0,0,0,1.53-1.53V3.46A1.54,1.54,0,0,0,20,1.93ZM19.74,13.3H2.26V3.68H19.74Z" transform="translate(-0.51 -1.93)"/><path d="M7.29,11.55a.66.66,0,0,1-.5-.23.64.64,0,0,1,.07-.92L9.92,7.77a.65.65,0,0,1,.79,0l.86.57L14,5.84a.67.67,0,0,1,.93,0,.65.65,0,0,1,0,.93L12.12,9.61a.66.66,0,0,1-.83.08l-.89-.6-2.69,2.3a.61.61,0,0,1-.42.16Z" transform="translate(-0.51 -1.93)"/><path d="M14.71,8.93a.65.65,0,0,1-.46-.2L12.07,6.55a.65.65,0,0,1-.15-.71.66.66,0,0,1,.61-.41h2.18a.65.65,0,0,1,.66.66V8.27a.66.66,0,0,1-.4.61A.8.8,0,0,1,14.71,8.93Z" transform="translate(-0.51 -1.93)"/>
                    </svg>
                    <br>
                    <span>{{ $t('analytics') }}</span>
                </label>
            </li>    
            <!-- <li title="support">
                <label for="tab4" data-qa="supportTabButton" role="button" style="font-size: 1.8em;">
                    <svg viewBox="0 0 24 24">
                      <path d="M1.35,11.85v2.26a2.08,2.08,0,0,0,2.08,2.07H4.56a.56.56,0,0,0,.56-.57V9.77H3.43A2.08,2.08,0,0,0,1.35,11.85Z" transform="translate(-1.35 -0.35)"/><path d="M14.58,11.47v-3a1.32,1.32,0,0,0-1.32-1.31H8.74A1.32,1.32,0,0,0,7.42,8.45v3a1.32,1.32,0,0,0,1.32,1.32H10l2.11,1.75a.53.53,0,0,0,.36.13.52.52,0,0,0,.24-.05.55.55,0,0,0,.32-.51V12.79h.19A1.32,1.32,0,0,0,14.58,11.47Zm-2.83-.94h-1.5A.57.57,0,0,1,9.68,10a.56.56,0,0,1,.57-.56h1.5a.56.56,0,0,1,.57.56A.57.57,0,0,1,11.75,10.53Z" transform="translate(-1.35 -0.35)"/><path d="M8.93,18.52a1.13,1.13,0,0,0,1.13,1.13h1.88a1.13,1.13,0,1,0,0-2.26H10.06A1.12,1.12,0,0,0,8.93,18.52Z" transform="translate(-1.35 -0.35)"/><path d="M17.26,17.31v.11a.57.57,0,0,1-.57.57H14.14a2.26,2.26,0,0,1,.06.53,2.35,2.35,0,0,1-.08.6h2.57a1.7,1.7,0,0,0,1.7-1.7v-.11Z" transform="translate(-1.35 -0.35)"/><path d="M18.57,9.77H16.88v5.84a.56.56,0,0,0,.56.57h1.13a2.08,2.08,0,0,0,2.08-2.07V11.85A2.08,2.08,0,0,0,18.57,9.77Z" transform="translate(-1.35 -0.35)"/><path d="M16.76,2.74A8.14,8.14,0,0,0,2.86,8.49v.15H5.12V8.49a5.88,5.88,0,1,1,11.76,0v.15h2.26V8.49A8.09,8.09,0,0,0,16.76,2.74Z" transform="translate(-1.35 -0.35)"/>
                    </svg>
                    <br>
                    <span>{{ $t('support') }}</span>
                </label>
            </li> -->
        </ul>
        <div class="slider">
            <div class="indicator"></div>
        </div>
        <div class="content">
            <section>
                <h2>{{ $t('ecommerce') }}</h2>
                <div class="about-container">
                    <figure class="about-img img-wrapper">
                        <img src="../../assets/static/images/illustrations/ecommerce.svg" />
                    </figure>
                    <div class="about-text">
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature1_1') }}</span>
                        </p>
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature1_2') }}</span>
                        </p>
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature1_3') }}</span>
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature1_4') }}</span>
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2_cb.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left" style="color: #e0e0e0;">{{ $t('feature1_6') }}</span>
                        </p>
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2_cb.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left" style="color: #e0e0e0;">{{ $t('feature1_5') }}</span>
                        </p>
                    </div>
                </div>
            </section>
            <section>
                <h2>{{ $t('inventory') }}</h2>
                <div class="about-container">
                    <figure class="about-img img-wrapper">
                        <img src="../../assets/static/images/illustrations/team.svg" />
                    </figure>
                    <div class="about-text">
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature2_1') }}</span>
                        </p>
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature2_3') }}</span>
                        </p>
                        <p class="feature"> 
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature2_2') }}</span>
                        </p>
                        <p class="feature"> 
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature2_4') }}</span>
                        </p>
                    </div>
                </div>
            </section>
            <section>
                <h2>{{ $t('support') }}</h2>
                <div class="about-container">
                    <figure class="about-img img-wrapper">
                        <img src="../../assets/static/images/illustrations/support.svg" />
                    </figure>
                    <div class="about-text">
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature3_1') }}</span>
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature3_2') }}</span>
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2.svg" alt="logo" width="24" height="24"></span>
                          <span class="mg-left">{{ $t('feature3_3') }}</span>
                        </p>
                    </div>
                </div>

            </section>
            <section>
                <h2>{{ $t('analytics') }}</h2>
                <div class="about-container">
                    <figure class="about-img img-wrapper">
                        <img src="../../assets/static/images/illustrations/metrics1.svg" />
                    </figure>
                    <div class="about-text">
                        <p class="coomingSoon">{{ $t('soon') }}</p>
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2_cb.svg" alt="logo" width="24" height="24"></span>
                          <span style="color: #e0e0e0;" class="mg-left">{{ $t('feature4_1') }}</span>
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2_cb.svg" alt="logo" width="24" height="24"></span>
                          <span style="color: #e0e0e0;" class="mg-left">{{ $t('feature4_2') }}</span>
                        <p class="feature">
                          <span><img class="mb-2" src="../../assets/static/icons/expar_logo_new2_cb.svg" alt="logo" width="24" height="24"></span>
                          <span style="color: #e0e0e0;" class="mg-left">{{ $t('feature4_3') }}</span>
                        </p>
                    </div>
                </div>

            </section>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

// @import "bourbon";

/* colors */
$primary: #fb7377;
$dark: #0c2e44;

$accent: $primary;
$accent-inactive: desaturate($accent, 85%);
$secondary: $accent-inactive;


/* tab setting */
$tab-count: 4;
$indicator-width: 50px;
$indicator-height: 4px;

/* breakpoints */
$breakpoints: (
  medium: #{$tab-count*250px},
  small: #{$tab-count*150px}
);


/* selectors relative to radio inputs */
$label-selector: "~ ul > li";
$slider-selector: "~ .slider";
$content-selector: "~ .content > section";

@mixin tabs(
  $label-selector: $label-selector,
  $slider-selector: $slider-selector,
  $content-selector: $content-selector) {
    
  @for $i from 1 through $tab-count {
    &:nth-of-type(#{$i}):checked {
      #{$label-selector}:nth-child(#{$i}) {
        @content;
      }
      #{$slider-selector} {
        transform: translateX(#{100% * ($i - 1)});
      }
      #{$content-selector}:nth-child(#{$i}) {
        display: block;
      }
    }
  }
}

body {
  background: #efefef;
  color: $dark;
  height: 100%;
  
  h1 {
    text-align: center;
    color: $accent;
    font-weight: 300;
    padding: 40px 0 20px 0;
    margin: 0;
  }
}

.coomingSoon {
      text-transform: uppercase;
      letter-spacing: 5px;
      font-size: 2em;
      font-weight: 600;
}

.mg-left {
  margin-left: 10px;
}

.tabs {
  left: 50%;
  transform: translateX(-50%);
  position: relative;
  background: white;
  padding: 30px;
  padding-bottom: 80px;
  width: 96%;
  max-width: 1150px;
  height: 650px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
  min-width: #{$tab-count * 60px};
  input[name="tab-control"] {
    display: none;
  }
  
  .content section h2,
  ul li label {
    font-weight: 400;
    font-size: 18px;
    color: $accent;
    text-align: left;
  }
  
  ul {
    list-style-type: none;
    padding-left: 0;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    
    li {
      box-sizing: border-box;
      flex: 1;
      width: #{100%/$tab-count};
      padding: 0 10px;
      text-align: center;
      
      label {
        transition: all 0.3s ease-in-out;
        color: $secondary;
        padding: 5px auto;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        white-space: nowrap;
        -webkit-touch-callout: none;
        user-select: none;
        // @include user-select(none);
        
        br {
          display: none;
        }
        
        svg {
          fill: $dark;
          height: 1.2em;
          vertical-align: bottom;
          margin-right: 0.2em;
          transition: all 0.2s ease-in-out;
        }
        &:hover,
        &:focus,
        &:active {
          outline: 0;
          color: lighten($secondary, 15%);
          svg {
            // fill: lighten($secondary, 15%);
            fill: lighten(black, 15%);
          }
        }
      }
    }
  }
  
  .slider {
    position: relative;
    width: #{100%/$tab-count};
    transition: all 0.33s cubic-bezier(0.38, 0.8, 0.32, 1.07);
    .indicator {
      position: relative;
      width: $indicator-width;
      max-width: 100%;
      margin: 0 auto;
      height: $indicator-height;
      background: $accent;
      border-radius: 1px;     
    }

  }
  
  .content {
    margin-top: 30px;
    
    section {
      display: none;
      animation: {
        name: content;
        direction: normal;
        duration: 0.3s;
        timing-function: ease-in-out;
        iteration-count: 1;
      }
      line-height: 1.4;
      
      h2 {
        color: $accent;
        display: none;
        &::after {
          content: "";
          position: relative;
          display: block;
          width: 30px;
          height: 3px;
          background: $accent;
          margin-top: 5px;
          left: 1px;
        }
      }
    }
  }
  
  input[name="tab-control"] {
    @include tabs {
      > label {
        cursor: default;
        color: $accent;
        
        svg {
          fill: $accent;
        }
        
        @media (max-width: map-get($breakpoints, small)) {
          background: rgba(0, 0, 0, 0.08);
        }
      }
    }
  }

  @keyframes content {
    from {
      opacity: 0;
      transform: translateY(5%);
    }
    to {
      opacity: 1;
      transform: translateY(0%);
    }
  }
  
  @media (max-width: map-get($breakpoints, medium)) {
    ul li label {
      white-space: initial;
      
      br {
        display: initial;
      }
      
      svg {
        height: 1.5em;
      }
    }
  }
  
  @media (max-width: map-get($breakpoints, small)) {
    ul li label {
      padding: 5px;
      border-radius: 5px;
      
      span {
        display: none;
      }
    }

   
    .slider {
      display: none;
    }
    
    .content {
      margin-top: 20px; 
      section h2 {
        display: block;
        text-align: left;
      }
    }
      .about-img {
    padding: 0em;
    margin: 5px;
    vertical-align: top;
  }
  .about-text {
    display: inline-block;
    /* max-width: 400px; */
    text-align: left;
  }
  .about-text2 {
    display: inline-block;
    /* max-width: 400px; */
    text-align: left;
    color: var(--grey-light);
    font-weight: 600;
    font-size: 1.4em;
  }

  .about-text br {
    padding: 0px;
    margin: 0px;
  }

  .predgovor {
    font-size: 3vh;
    text-align: left;
    line-height: 1.3em;
  }
.tabs {
  width: 95% !important;
  height: 600px;
}

  .about-img {
  max-width: 150px;
}
.feature {
  font-size: 2vh;
}
  }
}


.img-wrapper {
  width: auto;
  position: relative;
}
.img-wrapper > img {
  position: relative;
}
.about-container {
  text-align: center;
}
.about-img {
  display: inline-block;
  width: 100%;
  max-width: 310px;
  text-align: left;
  vertical-align: top;
}
.about-img img {
    width: 100%;
}

.about-text {
  display: inline-block;
  max-width: 500px;
  text-align: left;
  margin-top: 5px;
  margin-left: 50px;
  padding: 5px;
  margin: 5px;
}

.feature {
  font-size: 2.5vh;
  text-align: left;
  line-height: 1.3em;
  color: $dark;
}

/* SMARTPHONES LANDSCAPE */
@media only screen and (min-device-width: 480px) and (max-device-width: 820px) and (orientation: landscape) {
.tabs {
  max-height: 550px;
  height: 100%;
}
.tabs .about-img{
    max-width: 200px;
}
.tabs .feature {
    font-size: 4vh;
}
.about-img {
display: none;
}
.tabs ul li label span {
  font-size: 1.3rem;
}
}


@media only screen and (min-device-width: 360px) and (max-device-width: 416px) and (orientation: portrait) {
.tabs {
  height: 700px;
}
.feature {
  font-size: 1.7vh;
}
}

//iPhone 5 //
@media only screen and (min-device-width: 320px) and (max-device-width: 359px) and (orientation: portrait) {
.tabs {
  height: 700px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
.tabs {
  height: 400px;
  }
}

//  iPhone 12 Mini, iPhone 11 Pro, iPhone Xs, and iPhone X
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .tabs {
  height: 730px;
}
.feature {
  font-size: 1.3vh;
}
 }

//iPad //
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {
    .tabs {
  height: 950px;
}
.about-img {
    max-width: 200px;
}
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {
}


</style>